import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { timeUtils } from '@/server-data'
import { selectUserConfiguration } from '@/features/domain/user'

export function useCreateFormatDate() {
  const userConfig = useSelector(selectUserConfiguration)

  return useCallback(
    (source: string | Date, shortFormat: boolean = false) =>
      timeUtils.formatDate(userConfig)(source, shortFormat),
    [userConfig],
  )
}
